import React, { useEffect, useRef, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks";
//
import MainTemplate from "@/components/Templates/MainTemplate";
import TopSection from "./TopSection";
import KeysWebinar from "./WebinarKeys";
import PartnerPrograms from "./PartnerPrograms";
import AllPackages from "@/containers/WellnessPrograms/AllPackages";
import PinkBoxComponent from "./PinkBox";
import PartnerBanner from "./PartnerBanner";
import TestimonialsV2 from "@/containers/DoctorsLandingPage/testimonialsV2";
//
import theme from "@/foundation/Theme";
import { useWindowDimensions } from "@/hooks";
import { isMobile, timezone } from "@/utils";
import { getHealthProgramPage as healthDetailsApi } from "@/redux/HealthProgramReducer";
import { getCountryCodes as countryCodeApi } from "@/redux/DashboardReducer";
//
import { mapPartnerBannerData } from "../WellnessPrograms/mapWellnessProgram";
import useDisableIntercom from "@/hooks/useDisableIntercom";
import { mapPartnershipProgramData } from "./mapPartnershipProgramData";
//
function PartnerHealthPrograms({ slug }) {
  const topRef = useRef(null);

  const { width } = useWindowDimensions();

  useDisableIntercom({});

  const { countryCodeData: countryCodes } = useAppSelector(
    (state) => state.dashboard
  );
  const { isLoading, success, data, error } = useAppSelector(
    (state) => state.partnershipPage
  );

  const { forms, pageTypeData, formattedData } = useMemo(() => {
    return mapPartnershipProgramData(data, slug);
  }, [success]);

  const {
    isCorporatePartnership,
    isOldUserReactivationPage,
    isVisaMastercardPartnership,
  } = pageTypeData;

  return (
    <MainTemplate
      success={success}
      error={error}
      hideHeader
      noIndexNoFollow={true}
    >
      <TopSection
        data={data}
        countryCodes={countryCodes}
        slug={slug}
        topRef={topRef}
        success={success}
        isMobile={isMobile}
        width={width}
        {...forms}
        {...pageTypeData}
        {...formattedData}
      />
      <KeysWebinar data={data} />
      {isCorporatePartnership && (
        <PartnerPrograms
          registrationFormRef={topRef}
          buttonText={
            isVisaMastercardPartnership && data?.floating_banner?.title
          }
        />
      )}
      {(isCorporatePartnership || isOldUserReactivationPage) && (
        <AllPackages
          planData={data?.all_packages}
          programType={slug}
          isCorporatePage={isCorporatePartnership}
          isOldUserReactivationPage={isOldUserReactivationPage}
          openPaymentPage={(data) => {}}
        />
      )}
      <PinkBoxComponent isMobile={isMobile} data={data} width={width} />
      {data?.partner_detail?.thumbnail && (
        <PartnerBanner width={width} {...mapPartnerBannerData(data)} />
      )}
      {data?.testimonials?.components?.length > 0 && (
        <TestimonialsV2
          isMobile={isMobile}
          headingColor={theme.colorsV2.blue.shade_700}
          wrapperBG={theme.colorsV2.blueGray.shade_50}
          wrapperPadding={{
            desktop: "40px 0 42px 0",
            mobile: "32px 0 2px",
          }}
          arrowImage={"arrow-new-blue.svg"}
          data={data?.testimonials}
          mobilePadding={"16px"}
        />
      )}
    </MainTemplate>
  );
}

export default PartnerHealthPrograms;
